export default __webpack_public_path__ + "static/media/close.62e01eec.svg";